import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import style from "css/menu.module.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// import queryString from 'query-string';

function Footer() {
  const navigate = useNavigate();
  const [pageCount, setPageCount] = useState(0);
  const [notice, setNotice] = useState([]);
  const [isIncrease, setIsIncrease] = useState(true);

  const getNotice = useCallback(() => {
    axios.get("/notice/data/menu").then((res) => {
      if (res.status === 200) {
        setNotice(res.data);
      }
    });
  }, []);

  const noticeTimer = useCallback(() => {
    return setTimeout(() => {
      if (pageCount === notice.length - 1) {
        setPageCount(0);
      } else {
        setPageCount(pageCount + 1);
      }
    }, 10000);
  }, [notice.length, pageCount]);

  useLayoutEffect(() => {
    getNotice();
  }, [getNotice]);

  useEffect(() => {
    if (isIncrease && notice.length > 0) {
      noticeTimer();
    } else {
      clearInterval(noticeTimer);
    }
  }, [isIncrease, notice.length, noticeTimer]);

  return (
    <div className={style.footer}>
      <div className={style.footer_article}>
        <div className={style.footer_title}>News & Notice</div>
        <div className={style.footer_date}>{notice[pageCount]?.date}</div>
        <div
          className={`${style.footer_notice} cursor`}
          onClick={() => navigate(process.env.REACT_APP_CLIENT_URL + "app/notice?ID=" + notice[pageCount]?.ID)}
        >
          {notice[pageCount]?.content}
        </div>
      </div>

      <div className={style.footer_paging}>
        {notice.length > 0 && (
          <>
            <div className={style.paging_num}>
              {pageCount + 1} / {notice.length}
            </div>

            <div className={style.paging_direction}>
              <img
                className={`${style.direction_left} cursor`}
                onClick={() => {
                  if (pageCount === 0) {
                    setPageCount(notice.length - 1);
                  } else {
                    setPageCount(pageCount - 1);
                  }

                  if (!isIncrease) {
                    setIsIncrease(true);
                  }
                }}
                src={process.env.REACT_APP_CLIENT_URL + "img/menu/notice_left.png"}
                alt=""
              />
              <img
                className={`${style.direction_stop} cursor`}
                src={process.env.REACT_APP_CLIENT_URL + "img/menu/notice_stop.png"}
                alt=""
                onClick={() => setIsIncrease(false)}
              />
              <img
                className={`${style.direction_right} cursor`}
                onClick={() => {
                  if (pageCount === notice.length - 1) {
                    setPageCount(0);
                  } else {
                    setPageCount(pageCount + 1);
                  }

                  if (!isIncrease) {
                    setIsIncrease(true);
                  }
                }}
                src={process.env.REACT_APP_CLIENT_URL + "img/menu/notice_right.png"}
                alt=""
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Footer;
